var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"8","stroke":"currentColor","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M9 7V11H11","stroke":"currentColor","strokeWidth":"4","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ClockIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
